<filter-expandable [filter]="filter"
                   [isDefault]="isDefault">
    <ul style="padding-left: 3px;"
        class="m-b-2"
        [ngClass]="filter.attribute.data?.isSwatch ? 'm-t--1-s' : 'm-t--1 m-t-0-s m-t-0-m'"
        [grid]="1"
        [gridColumnGap]="'8px'"
        [gridRowGap]="'0px'">
        <li [gridColumn]="1"
            [ngClass]="filter.attribute.data?.isSwatch ? 'm-t-7' : 'm-t-8 m-t-7-s m-t-7-m'"
            *ngFor="let option of filter.optionsWithMatches; let isFirst = first; let isLast = last; trackBy filter.optionTrackByFn">

            <button type="button"
                    (click)="filter.toggle(option)"
                    class="flex flex-middle w-12"
                    [class.is-disabled]="filter.isUnavailble(option)"
                    [ngSwitch]="filter.attribute.data?.isSwatch">
                <href [link]="option | facetUrl : filter">
                    <span class="flex flex-middle flex-wrap">
                        <ng-container *ngSwitchCase="true">
                            <swatch [option]="filter.attribute.data.isSwatch ? option : 'checkbox'"
                                    [isBig]="true"
                                    [selected]="filter.isSelected(option)"
                                    class="inline-block m-r-3"></swatch>

                        </ng-container>

                        <ng-container *ngSwitchCase="false">
                            <i [ngClass]="filter.isSelected(option) ? 'icon-radio-on' : 'icon-radio-off'"
                               class="col-1 option__icon  flex flex-middle m-r m-r-3-s"></i>

                        </ng-container>
                        <span class="col-1 inline-block"
                              [ngClass]="filter.isSelected(option) ? 's2' : 'p2'">{{option.label}}</span><span
                              class="p2 col-12 inline-block m-l-1">{{'(%)' | translate:
                            filter.getCurrentMatchesCount(option)}}</span>
                    </span>
                </href>
            </button>
        </li>
    </ul>
</filter-expandable>
